import {elementFrom} from "../../../common/utils/html";
import {UnLitElement} from "../../../common/elements";
import {property} from "lit/decorators.js";
import {type DialogOpener, DialogOpenerFactory} from "./dialogOpener";
import {resolve} from "../../../container";

export abstract class DialogAnchorTemplateContent extends UnLitElement {

    @property({attribute: "disable-close-on-outside-click", type: Boolean})
    public disableCloseOnOutsideClick: boolean = false;

    @property({attribute: "active-from-breakpoint", type: String})
    public activeFromBreakpoint: string = "xs";

    @property()
    public label: string;

    private dialogOpenerFactory: DialogOpenerFactory = resolve(DialogOpenerFactory);
    private dialogOpener: DialogOpener;
    protected dialogContent: HTMLElement;

    public connectedCallback(): void {
        super.connectedCallback();

        const dialogTemplate = this.resolveTemplateElement("content");

        if (!dialogTemplate) {
            return;
        }

        const dialogHtml = dialogTemplate.innerHTML;
        this.dialogContent = elementFrom<HTMLElement>(dialogHtml);
        this.dialogOpener = this.dialogOpenerFactory.createWithAnchor(this.dialogContent, this, this.activeFromBreakpoint, this.disableCloseOnOutsideClick);
    }

    public openDialog(e: Event): void {
        this.dialogOpener.openDialog(e);
    }
}
